var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:assets' to update
import Asset from '../asset-internal';
function RLogomark(_a) {
    var restProps = __rest(_a, []);
    return (_jsx(Asset, Object.assign({ viewBox: "0 0 40 40" }, restProps, { children: _jsx("path", { fill: "currentColor", d: "M17.184 28.928C9.69 28.037 4 23.652 4 18.378 4 12.46 11.163 7.662 20 7.662s16 4.798 16 10.716c0 3.02-1.866 5.749-4.867 7.696l3.713 6.261-6.168.003-2.213-4.156a22.042 22.042 0 0 1-3.823.765v3.386l-5.458.002v-3.407zm5.458-2.426c.969-.006 1.901-.06 2.785-.163-.188-.281-.414-.587-.588-.727-.303-.245-.432-.333-.732-.333h-1.466l.001 1.223zm7.608-1.461a3.58 3.58 0 0 0-.352-.205c-.562-.285-1.531-.577-1.531-.577s4.771-.354 4.771-5.103-4.993-4.84-4.993-4.84H17.184v11.467c-4.08-1.182-6.896-3.696-6.896-6.605 0-4.046 5.445-7.326 12.161-7.326 6.717 0 11.673 2.244 11.673 7.326 0 2.759-1.461 4.682-3.872 5.863zm-4.257-6.816-3.304-.002-.002 3.064 3.306-.001s1.531-.005 1.531-1.559c0-1.585-1.531-1.502-1.531-1.502z", fillRule: "evenodd", clipRule: "evenodd" }) })));
}
export default RLogomark;
